import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=c61298ac&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Message.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Message.vue?vue&type=style&index=0&id=c61298ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61298ac",
  null
  
)

export default component.exports